import React, { useState } from "react"
import { useQueryData, userInfo, userRole } from "utils"
import { Card, Alert, CardBody } from "reactstrap"
import { Link } from "react-router-dom"
import { useMutation } from "@apollo/react-hooks"
import { withRouter } from "react-router"
import withModal from "components/modal"
import { Spinner } from "components/spinner"
import { withBreadcrumb, useBread } from "components/breadcrumb"
import { SHOPPING_CART as SHOPPING_CART_HEADER } from "components/layouts/gql"
import ShoppingCartStep from "./ShoppingCartStep"
import ShoppingCartItems from "./ShoppingCartItems"
import ShoppingCartFinish from "./ShoppingCartFinish"
import ShoppingOperational from "./ShoppingOperational"
import { processType } from "../helper"
import { SHOPPING_CART, SUBMIT_ORDER } from "../gql"

import "../styles/style.scss"

const ShoppingCartContainer = props => {
  const { data, loading, writeData } = useQueryData(SHOPPING_CART, {
    variables: {
      ...(props.match.params.id && { companyId: props.match.params.id })
    },
    fetchPolicy: "cache-and-network"
  })
  const { role } = userInfo()
  const [submitOrder] = useMutation(SUBMIT_ORDER, {
    refetchQueries: [{ query: SHOPPING_CART_HEADER }]
  })

  const [shoppingCartId, setShoppingCartId] = useState(data?.shoppingCart?.id)
  const [delivery, setDelivery] = useState("WITH_RECEIPT")
  const [processed, setProcessed] = useState(processType.STEP1)

  useBread({ to: props.match.url, name: "購物車" }, true)

  /**
   * Change Step
   * @param {*} step
   */

  const setStepChange = step => {
    setShoppingCartId(data.shoppingCart.id)
    if (step === processType.STEP3 && role === userRole.CUSTOMER) {
      props.modal.setCentered(false)
      props.modal.setModalSize("md")
      props.modal.setHeaderText("系統提示")
      props.modal.setHideCancel(false)
      props.modal.setSubmitText("確認")
      props.modal.setModalContent(<div>請再次確認品項、數量及金額是否正確</div>)
      props.modal.setOnSubmit(() => {
        submitOrder({
          variables: {
            id: data?.shoppingCart?.id,
            deliveryType: delivery
          }
        })
        setProcessed(processType[step])
      })
      props.modal.toggle()
      return
    }
    if (step === processType.STEP3) {
      submitOrder({
        variables: {
          id: data?.shoppingCart?.id,
          deliveryType: delivery
        }
      })
    }
    setProcessed(processType[step])
  }

  const renderStepComponent = () => {
    if (
      data?.shoppingCart?.orderDetails?.length <= 0 &&
      processed !== processType.STEP3
    ) {
      return (
        <div className="text-center">
          <Alert color="warning">
            尚未選取任何商品，請至<Link to="/product">商品清單</Link>
            選取
          </Alert>
        </div>
      )
    }

    if (processed === processType.STEP1 || processed === processType.STEP2) {
      return (
        <>
          <ShoppingCartItems
            shoppingCartId={data.shoppingCart.id}
            orderDetails={data.shoppingCart.orderDetails}
            writeData={writeData}
            readOnly={processed === processType.STEP2}
          />
          {renderDeliveryType()}
        </>
      )
    }

    if (processed === processType.STEP3) {
      return (
        <ShoppingCartFinish
          shoppingCartId={shoppingCartId}
          renderDeliverySection={renderDeliveryType()}
        />
      )
    }
    return null
  }

  const renderDeliveryType = () => {
    return (
      <div
        className="operational-block"
        style={
          processed === processType.STEP3
            ? { width: "75%", margin: "0 auto" }
            : {}
        }
      >
        <label style={{ fontWeight: "bold" }}>貨品出貨方式</label>
        <div className="form-check">
          <label>
            <input
              type="radio"
              value="WITH_RECEIPT"
              disabled={
                processed === processType.STEP2 ||
                processed === processType.STEP3
              }
              checked={delivery === "WITH_RECEIPT"}
              onChange={e => setDelivery(e.target.value)}
              className="form-check-input"
            />
            請隨貨開立發票
          </label>
        </div>

        <div className="form-check">
          <label>
            <input
              type="radio"
              value="WITHOUT_RECEIPT"
              disabled={
                processed === processType.STEP2 ||
                processed === processType.STEP3
              }
              checked={delivery === "WITHOUT_RECEIPT"}
              onChange={e => setDelivery(e.target.value)}
              className="form-check-input"
            />
            貨品先出，發票等通知開立
          </label>
        </div>
      </div>
    )
  }

  if (loading || !data) {
    return <Spinner />
  }

  return (
    <>
      <Card>
        <CardBody>
          <div className="step-block">
            <ShoppingCartStep processed={processed} />
          </div>

          <div className="step-container">{renderStepComponent()}</div>
          <div className="operational-block mt-3 mb-3">
            <ShoppingOperational
              productLength={data.shoppingCart.orderDetails.length}
              shoppingCartId={shoppingCartId}
              processed={processed}
              onChangeStep={step => {
                setStepChange(step)
              }}
            />
          </div>
        </CardBody>
      </Card>
    </>
  )
}

export default withRouter(withBreadcrumb(withModal(ShoppingCartContainer)))
